/**
 * keeping this on FE for now as there's no way to retrieve this BE limitation
 */
export const MAX_GOOGLE_FOLDER_SYNC_ITEMS_COUNT = 1000;
